import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';
import React, { Component } from 'react';

import { Control, LocalForm, Errors } from 'react-redux-form';
import PropTypes from 'prop-types';
import Alert from '../../container/Alert';
import AlertTranslation from '../../container/AlertTranslation';
import Header from '../Header';
import { Helmet } from 'react-helmet';
import Footer from '../Footer';
import { validator } from 'fast-json-patch';
import Spinner from '../Snowflake/as/Spinner';
const messages = defineMessages({
  htmlHeader: {
    id: 'preview.html.headerAna',
    description:
      'The title of the page that appears in the html header of the page.',
    defaultMessage: 'Assessment'
  },
  headerTitle: {
    id: 'assessment.header.title',
    description: 'Page Header Title',
    defaultMessage: 'Analyzer Report'
  },
  headerSubTitle: {
    id: 'assessment.header.subtitle',
    description: 'Page Header Subtitle',
    defaultMessage: 'Finalize project details to generate your Analyzer Report'
  },
  searchFiles: {
    id: 'preview.search.files',
    description: 'search files',
    defaultMessage: 'Search Files'
  },
  alertTitle: {
    id: 'preview.alert.title',
    description: 'Preview API alert title',
    defaultMessage: 'Loading Project Files Failed'
  }
});

const print = status => {
  if (status.payload) {
    // console.log(status.payload.response);
    return status.payload.response;
  }
};

// const handleShow = status =>{
//   return this.setState({show:true});
// };

// const AssesmentForDataEngineer = props => {
//   const { intl } = props;
class AssesmentForDataEngineer extends Component {

  constructor(props) {
    super(props);
    const { intl } = this.props;
    this.state ={
      show:false
    }
  }

  // componentWillUnmount() {

  //   this.handleShow()
  // }
render() {
  return (
    <div className={this.state.show ?"pageHide": "page"}>
      <Helmet>
        <title>{this.props.intl.formatMessage(messages.htmlHeader)} - SHIFT</title>
      </Helmet>
      <Header
        title={this.props.intl.formatMessage(messages.headerTitle)}
        subtitle={this.props.intl.formatMessage(messages.headerSubTitle)}
        icon="preview"
        locale={this.props.locale}
      />

{this.state.show ? (
<div   style={{display:"block"}}>
         <Spinner />

</div>):null}

      <AlertTranslation
        title="Exception"
        message={print(this.props.status)}
      />
      <div className="main">
        <div
          className="panel"
          style={{
            width: '60%',
            padding: '28px',
            boxSizing: 'content-box',
            marginTop: '15px',
            display: 'block',
            alignContent: 'center',
            marginLeft: 'auto',
            marginRight: 'auto'
          }}
        >
          <LocalForm
            className="form"
            onSubmit={({
              reponamefordataen,
              reponame,
              srclang,
              tgtlang,
              description,
              opportunity_num,
              clientname
            }) =>
              this.props.clickSubmitHandler(
                reponamefordataen,
                reponame,
                srclang,
                tgtlang,
                description,
                opportunity_num,
                clientname,
                this.props.username,
                this.props.name
              )
            }
          >
            <div
              style={{
                marginLeft: '3%'
              }}
            >
               <fieldset>
                <label style={{ textTransform: 'capitalize' }}>
                  <FormattedMessage
                    id="analyzer.staging.repository.name"
                    defaultMessage="Analyzer Staging Repository Name: "
                  />
                </label>

                <Control.select
                  model=".reponamefordataen"
                  autoFocus
                  required
                  defaultValue={this.props.reponamefordataen}
                 // onChange={this.props.getinfobyreponame}
                >
                  <option value="">Please select repository name</option>
                  {this.props.projectListfordataen.map(item => <option value={item}>{item}</option>)}
                </Control.select>
              </fieldset>
              <fieldset>
                <label style={{ textTransform: 'capitalize' }}>
                  <FormattedMessage
                    id="source.code.repository.name.fordataen"
                    defaultMessage="Source Code Repository Name: "
                  />
                </label>

                <Control.select
                  model=".reponame"
                  autoFocus
                  required
                  defaultValue={this.props.reponame}
                  onChange={this.props.getinfobyreponameforaccessment}
                >
                  <option value="">Please select repository name</option>
                  {this.props.projectList.map(item => <option value={item}>{item}</option>)}
                </Control.select>
              </fieldset>

              <fieldset>
                <label style={{ textTransform: 'capitalize' }}>
                  <FormattedMessage
                    id="snowflake.form.title"
                    defaultMessage="Client/Prospect Name: "
                  />
                </label>

                {this.props.role.includes('SALESMAN_ENGINEER')  ||
                this.props.role.includes('PROFESSIONAL_SERVICE') ||
                this.props.role.includes('TRANSLATION_MANAGEMENT')?  (
                <Control.text
                validators={{
                  length: val =>  `${val}`.length >0,
                  length2:  val =>  `${val}`.length<128
                }}
                  model=".clientname"
                  autoFocus
                  value={this.props.clientname}
                  onChange={this.props.clientnameChangeHandler}
                /> ):(
                  <Control.text
                  validators={{

                    length: val =>  `${val}`.length >0 &&  `${val}`.length<128
                   }}
                  model=".clientname"
                  autoFocus
                  value={this.props.clientname}
                  disabled
                  //required
                  />
               )}
                <Errors
                className="error"
                model=".clientname"
                messages={{
                  length: 'Client/Prospect Name: name can not be empty',
                  length2: 'Client/Prospect Name: name length can not be greater than 128'
                }}
              />
              </fieldset>

              <fieldset>
              <label style={{ textTransform: 'capitalize' }}>
                  <FormattedMessage
                    id="snowflake.form.opportunity"
                    defaultMessage="Opportunity Number: "
                  />
                </label>
              { this.props.role.includes('SALESMAN_ENGINEER') ||
                this.props.role.includes('PROFESSIONAL_SERVICE') ||
                this.props.role.includes('TRANSLATION_MANAGEMENT')?  (                         // original DATA_ENGINEER
                <Control.text
                validators={{
                 startwith: val => !val || `${val}`.startsWith('006'),
                 length: val => !val || `${val}`.length === 18
                }}
                  model=".opportunity_num"
                  //required
                  value={this.props.opportunity_num}
                  onChange={this.props.oppnumChangeHandler}
                />):(

                  <Control.text
                  validators={{
                    startwith: val => !val || `${val}`.startsWith('006'),
                    length: val => !val || `${val}`.length === 18
                  }}
                  model=".opportunity_num"
                  autoFocus
                  value={this.props.opportunity_num}
                  disabled
                />
                )}
                 <Errors
                  className="error"
                  model=".opportunity_num"
                  messages={{
                    startwith: 'Opportunity Number should start with 006. ',
                    length: 'Opportunity Number length should be 18.'
                  }}
                />
              </fieldset>

              <fieldset>
              <label style={{ textTransform: 'capitalize' }}>
                  <FormattedMessage
                    id="projects.project.source-languagee"
                    defaultMessage="Source Language: "
                  />
                </label>
                {/* <label onClick={print(status)}>test</label> */}
                { this.props.role.includes('SALESMAN_ENGINEER')  ||
                this.props.role.includes('PROFESSIONAL_SERVICE') ||
                this.props.role.includes('TRANSLATION_MANAGEMENT')?  (
                <Control.select
                  model=".srclang"
                  autoFocus
                  value={this.props.srclang}
                  onChange={this.props.srcChangeHandlerHandler}
                  //required
                >
                  <option value="">Please select source language</option>
                  <option value="netezza">Netezza</option>
                  <option value="teradata">Teradata</option>
                </Control.select>):  (
                 <Control.select
                  model=".srclang"
                  autoFocus
                  value={this.props.srclang}
                  disabled
                >
                  <option value="">Please select source language</option>
                  <option value="netezza">Netezza</option>
                  <option value="teradata">Teradata</option>
                 </Control.select>)}
              </fieldset>

              <fieldset>
                <label style={{ textTransform: 'capitalize' }}>
                  <FormattedMessage
                    id="projects.project.target-language"
                    defaultMessage="Target Language: "
                  />
                </label>

                 <Control.text readOnly
                  model=".tgtlang"
                  autoFocus
                  defaultValue="SnowSQL"
                />
              </fieldset>

              <fieldset>
              <label style={{ textTransform: 'capitalize' }}>
                  <FormattedMessage
                    id="comments.name"
                    defaultMessage="Description"
                  />
                </label>
                {/* <label onClick={print(status)}>test</label> */}
                {this.props.role.includes('SALESMAN_ENGINEER')  ||
                this.props.role.includes('PROFESSIONAL_SERVICE') ||
                this.props.role.includes('TRANSLATION_MANAGEMENT')?(
                <Control.text
                  model=".description"
                  autoFocus
                  value={this.props.description}
                  onChange={this.props.desHandlerHandler}

                />) : (
                  <Control.text
                  validators={{
                    length: val =>  `${val}`.length < 255
                  }}
                    model=".description"
                    autoFocus
                    value={this.props.description}
                    disabled


                  />
                  ) }

               <Errors
                  className="error"
                  model=".description"
                  messages={{

                    length: 'Description length can not great than 255.'
                  }}
                />
              </fieldset>

              <div className="button-container" style={{ textAlign: 'center' }}>
                <button
                  className="button"
                  type="button"
                  style={{ marginRight: '40px' }}
                  onClick={() => this.props.clickBackHandler()}
                >
                  <FormattedMessage
                    id="run-assessment.back.button.name"
                    defaultMessage="Back"
                  />
                </button>

                <button className="button" type="submit" disabled={this.props.flag}
                onClick={() =>
                      this.handleShow()}>
                  <FormattedMessage
                    id="submit.button.name"
                    defaultMessage="submit"
                  />
                </button>
              </div>
            </div>
          </LocalForm>
        </div>
      </div>
      <Footer />
    </div>
  );

}

handleShow(){
  const new_opp_num = JSON.parse(JSON.parse(sessionStorage.getItem("persist:shift"))['assessment'])['opportunity_num'];
  const new_clientname = JSON.parse(JSON.parse(sessionStorage.getItem("persist:shift"))['assessment'])['clientname'];
  const new_srclang = JSON.parse(JSON.parse(sessionStorage.getItem("persist:shift"))['assessment'])['srclang'];
  if (new_opp_num != null && new_opp_num.length==18 && new_opp_num.startsWith('006')
     && new_clientname != null && new_clientname.length>0 && new_clientname<128
     && new_srclang !=null && new_srclang != "" && new_srclang.length>0){
    this.setState({show:true})

    }

  }
}

AssesmentForDataEngineer.propTypes = {
  clickSubmitHandler: PropTypes.func.isRequired,
  projectList: PropTypes.array,
  projectListfordataen: PropTypes.array,
  title: PropTypes.string,
  opportunity: PropTypes.string,
  username: PropTypes.string,
  reponame: PropTypes.string,
  reponamefordataen: PropTypes.string,
  srclang: PropTypes.string,
  tgtlang: PropTypes.string
};

export default injectIntl(AssesmentForDataEngineer);



// WEBPACK FOOTER //
// ./src/components/views/AssesmentForDataEngineer/index.js